import React from 'react'

import { Layout } from 'antd'
import NavBar from './navbar/NavBar'
import PieDePagina from './footer/PieDePagina'
import { AiOutlineWhatsApp } from "react-icons/ai";

import '../../styles/layout.css'

const Plantilla = ({children, english}) => {

    const { Header, Content, Footer} = Layout

    return (
        <main>
            <Layout>
                <Header className="header">
                    <NavBar english={english} />
                </Header>
                <Content className="contenido-web">{children}</Content>
                <Footer className="footer">
                    <PieDePagina english={english} />
                    <p className="footer-avisos">
                        Todos los derechos reservados Cabo Marqués 2021. 
                        <a href="https://www.gmd.mx/pop_Corporativo.html" target="_blank" rel="nofollow">
                            Aviso de privacidad
                        </a> 
                    </p>
                </Footer>
                <div className="whatsapp">
                    <a href="https://wa.link/15zpd1" target="_blank" rel="nofollow">
                        <AiOutlineWhatsApp 
                            style={{color: 'white', fontSize: 35 }}
                        />
                    </a>
                </div>
            </Layout>
        </main>
    )
}

export default Plantilla